import * as model from "./model.js";
import homeView from "./views/homeView.js";
import cursorView from "./views/cursorView.js";
import projectsView from "./views/projectsView.js";
import contactsView from "./views/contactsView.js";
import themeView from "./views/themeView.js";
import menuView from "./views/menuView.js";
import ScrollTrigger from "gsap/ScrollTrigger";

//Render skills bar
const controlSkills = function () {
  homeView.renderSkillsBar(model.skills);
};

//Projects rendering
const controlProjects = function () {
  projectsView.renderLayout(model.projectsData);
};

const init = function () {
  //Mobile menu
  menuView.addHandlerOpenMenu();

  //Resize listener to recalculate dimensions
  let lastwidth = window.innerWidth;
  let resizeTimer;

  window.addEventListener("resize", () => {
    if (window.innerWidth === lastwidth) return;

    lastwidth = window.innerWidth;

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 250); // wait 250ms after the last resize before recalculating
  });

  //Cursor creation
  cursorView.addHandlerCursorListeners();

  //Theme switcher
  themeView.addHandlerChangeTheme();

  //Scroll Animations
  homeView.addHandlerInterceptHero();
  homeView.addHandlerInterceptAbout();

  //Render skills bar
  controlSkills();

  //Projects rendering
  controlProjects();
  projectsView.addHandlerProjectNav();
  contactsView.addHandlerScrollAnimation();
};

init();
